/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ExternalIdDTO } from './ExternalIdDTO';
import {
    ExternalIdDTOFromJSON,
    ExternalIdDTOFromJSONTyped,
    ExternalIdDTOToJSON,
    ExternalIdDTOToJSONTyped,
} from './ExternalIdDTO';

/**
 * 
 * @export
 * @interface WorkPersonOtherDTO
 */
export interface WorkPersonOtherDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkPersonOtherDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkPersonOtherDTO
     */
    givenname?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkPersonOtherDTO
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkPersonOtherDTO
     */
    role?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkPersonOtherDTO
     */
    sequence?: number;
    /**
     * 
     * @type {Array<ExternalIdDTO>}
     * @memberof WorkPersonOtherDTO
     */
    externalIds?: Array<ExternalIdDTO>;
}

/**
 * Check if a given object implements the WorkPersonOtherDTO interface.
 */
export function instanceOfWorkPersonOtherDTO(value: object): value is WorkPersonOtherDTO {
    return true;
}

export function WorkPersonOtherDTOFromJSON(json: any): WorkPersonOtherDTO {
    return WorkPersonOtherDTOFromJSONTyped(json, false);
}

export function WorkPersonOtherDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkPersonOtherDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'givenname': json['givenname'] == null ? undefined : json['givenname'],
                  'surname': json['surname'] == null ? undefined : json['surname'],
                  'role': json['role'] == null ? undefined : json['role'],
                  'sequence': json['sequence'] == null ? undefined : json['sequence'],
              'externalIds': json['externalIds'] == null ? undefined : ((json['externalIds'] as Array<any>).map(ExternalIdDTOFromJSON)),
    };
}

export function WorkPersonOtherDTOToJSON(json: any): WorkPersonOtherDTO {
    return WorkPersonOtherDTOToJSONTyped(json, false);
}

export function WorkPersonOtherDTOToJSONTyped(value?: WorkPersonOtherDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'givenname': value['givenname'],
        'surname': value['surname'],
        'role': value['role'],
        'sequence': value['sequence'],
        'externalIds': value['externalIds'] == null? value['externalIds']: (value['externalIds'] as Array<any>).map(ExternalIdDTOToJSON),
    };
}


